import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import Image from "next/image"
import Link from "next/link"
import { Fragment } from "react"
import { getCanonicalSlug, productLink, s3Url } from "@components/config/helpers"
import P from "@components/Components/Reusables/Typography/P"

const ProductVariants = ({ product_id, product_variants }) => {
    return (
        <>
            {/* <hr className="background-lightgrey mt-4 mb-3" /> */}
            <P className="uppercase m-0 p-0 mb-3 mt-2" as="h5" color="#333">Product Variants</P>
            <Box sx={{
                flexWrap: 'wrap',
                overflowX: {
                    xs: 'auto',
                    lg: 'inherit'
                },

            }} className="d-flex">
                {product_variants.map((variant, idx) => {
                    const urlLink = getCanonicalSlug({ canonical_category_slug: variant.canonical_category_slug, section_slug: variant.section_slug });

                    return (
                        <Fragment key={idx}>

                            <Box
                                sx={{
                                    width: 64,
                                    mr: 1.5,
                                    '&:hover .hover-underline-product::after': {
                                        width: '100%',
                                    },
                                }}
                            >
                                <Link
                                    shallow={true}
                                    href={productLink(urlLink, variant.product_slug)}
                                    passHref
                                    style={{
                                        textDecoration: 'none',
                                        color: 'inherit',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <Box
                                        title={`${variant.product_code} - ${variant.product_variant_label}`}
                                        className={product_id !== variant.product_variant_product_id ? 'hover-underline-product' : ''}
                                        sx={{
                                            display: 'block',
                                            width: 'fit-content',
                                            border: '2px solid white',
                                            mx: 'auto',
                                            ...(variant.product_id && product_id === variant.product_variant_product_id && {
                                                marginBottom: '4px',
                                                border: '2px solid var(--color-primary)',
                                            })
                                        }}>
                                        <Image
                                            className='mb-0 pb-0'
                                            style={{
                                                cursor: 'pointer',
                                                display: 'block',
                                            }}
                                            src={s3Url(variant.cart_image)}
                                            alt={variant.product_name}
                                            height={60}
                                            width={60}
                                            quality={75}
                                        />
                                    </Box>
                                    <Box className='pt-0 mt-0' sx={{ width: '100%' }}>
                                        {/* <p>{variant.product_variant_label}</p> */}
                                        <Typography
                                            className="d-block text-center mt-0 pt-0"
                                            component="small"
                                            variant="small"
                                            sx={{
                                                wordBreak: 'break-word',
                                                lineHeight: 1.2,
                                                color: 'inherit',
                                            }}
                                        >
                                            {variant.product_variant_label}
                                        </Typography>
                                    </Box>
                                </Link>
                            </Box>
                        </Fragment>
                    )
                })}
            </Box>
        </>
    )
}

export default ProductVariants